import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgMissing = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 18 27"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#FAFAFA'}
      stroke={props.stroke || '#E4E4E7'}
      strokeLinejoin="round"
      d="M8.914 1.805c-1.333 0-4.8-1.923-6.802.176-1.604 1.683-1.011 5.73.138 8.454.428 1.013.41 2.269.324 3.443-.344 4.702 1.19 11.94 2.592 11.856 1.438-.088 1.31-8.708 3.48-9.46 1.268-.439 1.564 1.821 1.845 3.938.337 2.532.139 5.176.854 5.448.833.315 2.414-1.805 3.253-5.656.452-2.07.646-4.408.59-6.097-.038-1.094-.04-2.459.388-3.472 1.15-2.723 1.743-6.77.138-8.453-2.002-2.1-5.468-.177-6.8-.177Z"
    />
  </svg>
);
export default SvgMissing;
